import { useLocation } from 'react-router-dom';

import { Box } from '@mui/material';

import { RoundedTitle } from '@/components/dashboard/Forms/SharedFormComponents';
import { useAppContext } from '@/context/context';

const PageTitleHeader = () => {
  const { selectedNav } = useAppContext();
  const location = useLocation();

  // help state - כל ה-hooks בתחילת הקומפוננטה

  // בדיקת תנאי אחרי כל ה-hooks
  const pagesWithLocalTitle: string[] = [];
  if (pagesWithLocalTitle.some(page => location.pathname.includes(page))) {
    return null;
  }

  const pageTitle = selectedNav.primary || getPageName(location.pathname);

  return (
    <Box
      sx={{
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <Box sx={{ position: 'relative', display: 'inline-block' }}>
        <RoundedTitle
          title={pageTitle}
          variant="h5"
          sx={{
            backgroundColor: 'grey.200',
            color: 'primary.contrastText',
            maxWidth: '450px', // הגדלתי את הרוחב המקסימלי// הוספתי רוחב מינימלי
            mx: 'auto',
            mb: 0,
            display: 'block',
            py: 0.5,
            px: 8,
            fontSize: '1rem',
            fontWeight: 100,
            lineHeight: 1.1,
            borderRadius: '25px',
            textAlign: 'center'
          }}
        />
      </Box>
    </Box>
  );
};

const getPageName = (pathname: string): string => {
  const routes: { [key: string]: string } = {
    '/details': 'פרטים אישיים'
  };

  // Remove trailing slash if present
  const normalizedPath = pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;

  // Check for exact match first
  if (routes[normalizedPath]) {
    return routes[normalizedPath];
  }

  // Check for partial matches for nested routes like '/crm/contact/:id'
  for (const route in routes) {
    if (normalizedPath.startsWith(route) && route !== '/') {
      return routes[route];
    }
  }

  // Split the path and get the first part (e.g., '/shluchim/123' becomes '/shluchim')
  const basePath = '/' + normalizedPath.split('/')[1];

  return routes[basePath] || 'דשבורד רשת';
};

export default PageTitleHeader;
